module.exports = __webpack_public_path__ + "7901456a.svg";